import React from 'react';
import PropTypes from 'prop-types';
import SideDate from './SideDate';
import { getInteractionDateParts } from '../utils/noteUtils';

const MessageNote = ({
  interactionDate,
  person,
  sender,
  text,
}) => {
  const {
    day,
    month,
    year,
    time,
  } = getInteractionDateParts(interactionDate);

  /* eslint-disable react/no-danger */
  return (
    <div className="flex p-3 py-4 bg-white border border-solid border-medium-border-blue rounded">
      <SideDate day={day} month={month} year={year} />
      <div className="inline-block flex-1 w-64 align-middle">
        <strong>Message</strong> sent to {person.full_name} by {sender.full_name} on
        {` ${month} ${day}, ${year}`} at {time}
        <div className="mt-2 whitespace-pre-wrap" dangerouslySetInnerHTML={{ __html: text }} />
      </div>
    </div>
  );
  /* eslint-enable react/no-danger */
};

MessageNote.propTypes = {
  interactionDate: PropTypes.object.isRequired,
  person: PropTypes.object.isRequired,
  sender: PropTypes.object.isRequired,
  text: PropTypes.string.isRequired,
};

export default MessageNote;
